import { type Toast, removeToast, subscribe } from "@/lib/toast";
import { useEffect, useState } from "react";

const typeStyles: Record<string, string> = {
	success: "bg-success text-white",
	error: "bg-danger text-white",
	info: "bg-primary text-white",
};

export function Toaster() {
	const [toasts, setToasts] = useState<Toast[]>([]);

	useEffect(() => {
		return subscribe(setToasts);
	}, []);

	if (toasts.length === 0) return null;

	return (
		<div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
			{toasts.map((t) => (
				<div
					key={t.id}
					className={`flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium shadow-lg ${typeStyles[t.type] ?? typeStyles.info}`}
				>
					<span className="max-w-xs">{t.message}</span>
					<button
						type="button"
						onClick={() => removeToast(t.id)}
						className="ml-2 opacity-70 hover:opacity-100"
					>
						&times;
					</button>
				</div>
			))}
		</div>
	);
}
